// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__2R9Ia","requiredAsterisk":"Info_requiredAsterisk__zlGdM"};